import { createDCHook, collapseDataFromCall } from '../../client';
import { getTelemetry } from '../../services/smartthermostat/TelemetryService';

export const useTelemetryGetTelemetry = createDCHook('getTelemetry', collapseDataFromCall(getTelemetry), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});
